export default __webpack_public_path__ + "static/media/lumen-dashboard-banner-1.88d9a94e.svg";